import { useLenis } from "lenis/react";
import { Instagram, Mail, MapPin } from "lucide-react";
import { IMAGES } from "../../data";

export const Footer = () => {
  const lenis = useLenis();
  const go = (id) => {
    const el = document.getElementById(id);
    if (el && lenis) lenis.scrollTo(el, { offset: -20 });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-20 pb-10 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-14 flex justify-center">
          <img
            src={IMAGES.logo}
            alt="Latte Stone Athletics — Training & Performance"
            data-testid="footer-logo"
            className="w-full max-w-md h-auto rounded-2xl"
          />
        </div>
        <div className="grid md:grid-cols-2 gap-10 md:gap-6 items-start">
          <div>
            <h2 className="font-display uppercase text-5xl md:text-7xl leading-[0.86]">
              Live on
              <br />
              <span className="text-outline">Vegas time.</span>
            </h2>
            <button
              data-testid="footer-cta"
              onClick={() => go("booking")}
              className="mt-8 inline-flex items-center gap-3 bg-[#e5ff00] text-black uppercase tracking-[0.18em] text-sm font-bold px-7 py-4 rounded-full hover:neon-glow transition-shadow duration-300"
            >
              Book Your Consult
            </button>
          </div>

          <div className="md:justify-self-end space-y-5 text-white/70">
            <a
              href="mailto:LatteStoneAthletics@outlook.com"
              data-testid="footer-email"
              className="flex items-center gap-3 hover:text-[#e5ff00] transition-colors duration-300"
            >
              <Mail size={18} /> LatteStoneAthletics@outlook.com
            </a>
            <div className="flex items-center gap-3">
              <MapPin size={18} /> Las Vegas, Nevada
            </div>
            <a
              href="https://instagram.com/aestheticmixo"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-3 hover:text-[#e5ff00] transition-colors duration-300"
            >
              <Instagram size={18} /> @aestheticmixo
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.18em] text-white/40">
          <span>© {new Date().getFullYear()} Latte Stone Athletics · Angelo Quitugua</span>
          <span>The Vegas Service Industry Coach</span>
        </div>
      </div>
    </footer>
  );
};
